<template>
  <v-card
    flat
    color="grey lighten-3"
    class="d-flex flex-column"
    >
    <v-card-title
      @click="show = !show"
      style="cursor: pointer"
      >
      <div>
        <div>
          Recibo del mes de {{ new Date(receipt.createdAt).toLocaleString('default', { month: 'long' }) }}
        </div>

        <div
          class="caption"
          >
          Fecha de creación: <span class="font-weight-bold">{{ (new Date(receipt.createdAt)).toLocaleDateString() }}</span>
        </div>
      </div>

      <v-spacer></v-spacer>

      <v-icon>
        {{ show ? 'mdi-chevron-up' : 'mdi-chevron-down' }}
      </v-icon>
    </v-card-title>

    <v-expand-transition>
      <div
        v-if="show"
        >
        <v-card-text
          class="grow"
          style="overflow: auto; height: 500px"
          >
          <v-row
            no-gutters
            class="px-3"
            >
            <v-col
              cols="7"
              class="caption"
              >
              Concepto
            </v-col>

            <v-col
              cols="2"
              class="caption text-right"
              >
              Monto
            </v-col>

            <v-col
              cols="3"
              class="caption text-right"
              >
              Fecha asiento
            </v-col>
          </v-row>
          <template
            v-for="(payment, i) in payments"
            >
            <payment
              :payment="payment"
              :client="client"
              :expanded="!i"
              ></payment>
          </template>
        </v-card-text>

        <v-card-actions
          class="px-4"
          >
          <v-spacer></v-spacer>
          <div
            class="fill-width text-right"
            >
            <div
              class="d-flex justify-end py-2 ml-auto"
              >
              <div
                class="d-flex justify-end"
                style="gap: 12px"
                >
                <span
                  class="font-weight-bold"
                  >
                  Total: 
                </span>

                <div
                  class="text-right"
                  style="width: 120px"
                  >
                  <div
                    v-for="payment in Object.entries(total)"
                    v-if="payment[1]"
                    >
                    {{ price(payment[1], payment[0]) }}
                  </div>
                </div>
              </div>
            </div>

            <div
              class="text-right"
              >
              <v-btn
                class="rounded-lg"
                color="primary"
                depressed
                @click="redirect"
                >
                Ver recibo
              </v-btn>
            </div>
          </div>
        </v-card-actions>
      </div>
    </v-expand-transition>
  </v-card>
</template>

<script>
import Payment from '@/components/payments/tenants/Payment'

export default {
  data: () => ({
    total: {
      "ARS": 0,
      "USD": 0
    },
    show: false,
    payments: []
  }),

  props: {
    receipt: {
      type: Object,
      required: true,
    },

    client: {
      type: Object,
      required: true,
    },

    clientType: {
      type: String,
      required: true,
    },
  },

  created () {
    this.total = {
      "ARS": 0,
      "USD": 0
    }

    let result = this.receipt.payments.reduce(function (r, a) {
      r[a.contractTag] = r[a.contractTag] || [];
      r[a.contractTag].push(a);
      return r;
    }, Object.create(null));

    this.payments = Object.entries(result)

    this.receipt.payments.forEach ( payment => {
      this.total[payment.currency] += payment.total
    })
  },

  methods: {
    redirect () {
      let routeData = this.$router.resolve({ name: this.clientType, params: { user_id: this.client.id, id: this.receipt.id } });
      window.open(routeData.href, '_blank');
    },

    price (amount, currency = "ARS") {
      const options = { style: 'currency', currency: currency };
      const numberFormat = new Intl.NumberFormat('es-AR', options);

      return numberFormat.format(Math.abs(amount))
    },
  },

  components: {
    Payment
  }
}
</script>
